exports = module.exports = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".IA_sharePointSiteCard_N-zKjVo6qfUGUb3bOVlU7{\n  display:flex;\n  align-items: center;\n  justify-content: space-between;\n}\n\n.IA_sharePointSiteWrapper_d6A1a-0HEfO0djhHseakr {\n  font-size: 14px;\n  float: left;\n  display: block;\n  width: 100%;\n  padding: 8px 0;\n}\n\n.IA_sharePointSiteId_177r7QHAGXiUKGEQysfEHI {\n  font-size: 9px;\n  opacity: 0.8\n}", ""]);

// Exports
exports.locals = {
	"IA_sharePointSiteCard": "IA_sharePointSiteCard_N-zKjVo6qfUGUb3bOVlU7",
	"IA_sharePointSiteWrapper": "IA_sharePointSiteWrapper_d6A1a-0HEfO0djhHseakr",
	"IA_sharePointSiteId": "IA_sharePointSiteId_177r7QHAGXiUKGEQysfEHI"
};